// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__V9kWG","protocol-modal-sms":"footer_protocol-modal-sms__gOer5"};